/**
 * /tos / /privacy / /cookies / /aup — migrated from public/js/tos.js.
 * Click pe .print declanseaza window.print().
 */
import { Resort } from '../core/resort.js';

new Resort(() => {
    $('.buttons', true).on('click', 'a.print', function () {
        window.print();
    });
});
